import { lazy } from "react";
import type { RouteObject } from "react-router";

const DormitoryIndex = lazy(() => import("./pages/page"));
const Dashboard = lazy(() => import("./pages/dashboard/page"));
const Buildings = lazy(() => import("./pages/buildings/page"));
const BuildingDetail = lazy(() => import("./pages/buildings/[id]/page"));
const Rooms = lazy(() => import("./pages/rooms/page"));
const RoomDetail = lazy(() => import("./pages/rooms/[id]/page"));
const Tenants = lazy(() => import("./pages/tenants/page"));
const TenantDetail = lazy(() => import("./pages/tenants/[id]/page"));
const Leases = lazy(() => import("./pages/leases/page"));
const LeaseDetail = lazy(() => import("./pages/leases/[id]/page"));
const MeterReadings = lazy(() => import("./pages/meter-readings/page"));
const MeterReadingDetail = lazy(() => import("./pages/meter-readings/[id]/page"));
const BillingPeriods = lazy(() => import("./pages/billing-periods/page"));
const BillingPeriodDetail = lazy(() => import("./pages/billing-periods/[id]/page"));
const Bills = lazy(() => import("./pages/bills/page"));
const BillDetail = lazy(() => import("./pages/bills/[id]/page"));
const RevenueReport = lazy(() => import("./pages/reports/revenue/page"));
const Settings = lazy(() => import("./pages/settings/page"));

export const dormitoryRoutes: RouteObject[] = [
  { index: true, Component: DormitoryIndex },
  { path: "dashboard", Component: Dashboard },
  { path: "buildings", Component: Buildings },
  { path: "buildings/:id", Component: BuildingDetail },
  { path: "rooms", Component: Rooms },
  { path: "rooms/:id", Component: RoomDetail },
  { path: "tenants", Component: Tenants },
  { path: "tenants/:id", Component: TenantDetail },
  { path: "leases", Component: Leases },
  { path: "leases/:id", Component: LeaseDetail },
  { path: "meter-readings", Component: MeterReadings },
  { path: "meter-readings/:id", Component: MeterReadingDetail },
  { path: "billing-periods", Component: BillingPeriods },
  { path: "billing-periods/:id", Component: BillingPeriodDetail },
  { path: "bills", Component: Bills },
  { path: "bills/:id", Component: BillDetail },
  { path: "reports/revenue", Component: RevenueReport },
  { path: "settings", Component: Settings },
];
